export default ({ defaultLocale, ingredients = [], isValidPath }) => ({
  getCategoryTitle: category => category.title[defaultLocale],
  getCategoryTitleField: category => category.title,
  getItemTitle: item => (ingredients.find(i => i.id === item.ingredientID) || {}).name || '',
  getItemDescription: item => (item.additionalDescription || {})[defaultLocale] || '',
  getId: item => item.ingredientID,
  isValidPath: path => isValidPath(path),
})
